import { createFileRoute } from "@tanstack/react-router";

import { GroupOverview } from "@/components/groups/group-overview";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/")({
  component: GroupOverviewTab,
});

function GroupOverviewTab() {
  const { groupId, currentUser, isAdmin, canPost } = useGroupRouteData(Route.useParams().groupId);

  return (
    <GroupOverview
      groupId={groupId}
      currentUserId={currentUser?._id}
      isAdmin={isAdmin}
      canPost={canPost}
    />
  );
}
